<template>
  <div>
    <p>Your payment failed. An updated payment is required to proceed with your promotion request.</p>
    <payment-gateway ref="paymentGateway"
                     :profile="SessionProfile"
                     @card-switch="cardSwitch"
                     @card="setCard"/>
    <gg-btn color="primary" @click="pay" tile :loading="loading">Pay</gg-btn>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import amapi from 'Api/amapi'
import PaymentGateway from 'Components/Common/PaymentGateway'

export default {
  name: 'PromoRequirePayment',
  components: {
    PaymentGateway,
  },
  props: {
    promo: {
      type: Object,
      required: true,
    },
    promo_request_id: {
      type: [Number, String],
      required: true,
    },
    paymentFailed: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      card: {},
      isNewCard: false,
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['SessionProfile']),
    creditCard () {
      switch (this.isNewCard) {
        case true:
          return {
            payment_method: 'creditcard',
            payment_cvv: this.card.cardnum_cvv,
            payment_cardnum: this.card.cardnum,
            payment_expdate: this.card.expdate
          }
        case false:
          return {
            payment_method: 'creditcard',
            payment_cvv: this.card.cardnum_cvv,
          }
        default:
          return {
            payment_method: 'creditcard',
            payment_cvv: this.card.cardnum_cvv,
          }
      }
    },
    paymentAmount () {
      return this.promo.payment_amount
    }
  },
  methods: {
    ...mapActions(['reportError']),
    setCard (card) {
      this.card = card
    },
    cardSwitch (val) {
      this.isNewCard = val
    },
    async pay () {
      const valid = await this.$refs.paymentGateway.validateForm()
      if (!valid) return
      const data = {
        promo_request_id: this.promo_request_id,
        ...this.creditCard
      }
      let response
      this.loading = true
      try {
        response = await amapi.makecall('promo_payment', data)
        console.log(response, data)
        if (response.result !== 'success') {
          throw new Error(response.resultmsg || 'Oops! Something went wrong.')
        }
        this.$emit('set-status', response.promo_status)
      } catch (err) {
        this.reportError(err)
      }
      this.loading = false
    }
  },
}
</script>
